import axios from "axios";
import toast from "react-hot-toast";

const nodeEnvironment = process.env.REACT_APP_PUBLIC_NODE_ENV;
const serverUrl = process.env.REACT_APP_PUBLIC_NODE_URL;
// const serverUrl = "http://192.168.30.9:8835";
// const serverUrl = "http://192.168.29.148:8836";
// const serverUrl = "http://10.210.111.119:8835";
const tokenName = process.env.REACT_APP_PUBLIC_TOKENNAME;

export const getToken = () => {
  const token = sessionStorage.getItem(tokenName || "moilToken");
  return token;
};

axios.interceptors.response.use(
  (response) => {
    if (response?.data?.status === 401 || response?.data?.status === "JWT_INVALID") {
      window.location.href = "/login";
      sessionStorage.clear();
      localStorage.clear();
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.data?.status === "JWT_INVALID") {
      window.location.href = "/login";
      sessionStorage.clear();
      localStorage.clear();
    }
    return Promise.reject(error);
  }
);

export function getServerUrl() {
  if (nodeEnvironment === "development") {
    return serverUrl;
  }

  if (nodeEnvironment === "machine_IP") {
    return serverUrl;
  }

  if (nodeEnvironment === "server") {
    return serverUrl;
  }

  return serverUrl;
}

export const communication = {
  login: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/login-user`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  resetPassword: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/reset-password`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  verifyOtp: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/verify-otp`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  changePassword: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/change-password`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },

  // ----------------------- All Master List Apis ------------------------------
  getEquipmentList: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/get-equipment-list`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getBarcodedEquipmentList: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/get-all-barcoded-equipment`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getCategoryWiseEquipmentList: async function (dataToSend) {
    try {
      console.log(dataToSend);
      return axios.get(`${getServerUrl()}/equipment/get-equipment-category-wise`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getCategoryWiseEquipmentListBySupervisor: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/get-equipment-category-wise-by-supervisor`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getEquipmentById: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/get-equipment-by-id`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  createAssignmentSupervisorEquipment: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/equipment-assignment/create-assignment`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  checkBarcode: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/check-barcode`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  updateBarcode: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/equipment/update-barcode`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getEmployeeList: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/employee/get-employee-list`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  failedRecordExport: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/employee/failed-record-export`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  employeeMissingDataReport: async function () {
    try {
      return axios.get(`${getServerUrl()}/employee/employee-missing-data-report`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  equipmentMissingDataReport: async function () {
    try {
      return axios.get(`${getServerUrl()}/employee/equipment-missing-data-report`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getOverallProduction: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/log/get-overall-production`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getEquipmentDashboardMetrics: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/get-equipment-dashboard-metrics`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getProductionApprovalCounts: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/log/get-production-approval-counts`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getGangMasterList: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/gang/get-gang-list`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getRateMasterList: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/rate/get-rate-list`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },

  // -------------------User Management APIs ---------------------------
  getUsersList: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/get-all-users`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getAssignments: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment-assignment/get-assignments`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getAssignmentById: async function (id) {
    try {
      return axios.get(`${getServerUrl()}/equipment-assignment/get-assignment-by-id`, {
        params: { id },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  updateAssignmentSupervisorEquipment: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/equipment-assignment/update-assignment`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getContractorUsers: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/contractor/list`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },

  getUserList: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/user/get-users-list`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  updateUserDesignation: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/update-user-designation`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  addContractorUser: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/contractor/create`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getContractorById: async function (id) {
    try {
      return axios.get(`${getServerUrl()}/contractor/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  updateContractor: async function (id, dataToSend) {
    try {
      return axios.put(`${getServerUrl()}/contractor/update/${id}`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  changeUserStatus: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/user/change-user-status`,
        { id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
    } catch (error) {
      toast.error(error?.message);
    }
  },
  createUser: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/create-user-manually`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  updateUser: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/user/update-user`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getUserById: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/user/get-user-by-id`,
        { id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getUserDesignationList: async function () {
    try {
      return axios.get(`${getServerUrl()}/user/get-all-designation`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getAllMines: async function () {
    try {
      return axios.get(`${getServerUrl()}/user/get-all-mines`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },

  getAllSupervisors: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/user/get-all-supervisors`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  // --------------------Equipment record  APIs ----------------------------

  getAllMaintenanceList: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/get-all-maintenance-list`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },

  getEquipmentCategoryQrStatus: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/get-equipment-category-qr-status`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getMaintenanceById: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/equipment/get-maintenance-by-id`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  // --------------------Equipment Exported SAP File   APIs ----------------------------

  getAllExportedSapFilesList: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/log/get-all-exported-sap-files`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  // --------------------Activity Sheet APIs ----------------------------

  getLogChartData: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/log/get-log-chart-data`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getAllLogbookList: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/log/get-all-logbook-list`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getLogById: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/log/get-log-by-id`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  bulkUpdateLog: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/log/bulk-update-log`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getActivityList: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/ug/get-activity-list`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getActivityById: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/ug/get-activity-by-id`,
        { id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
    } catch (error) {
      toast.error(error?.message);
    }
  },
  reassignActivity: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/ug/change-activity-status-reassign`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  approveActivity: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/ug/change-activity-status-approve`,
        { id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getRateByJobId: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/rate/get-rate-by-job`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  updateActivity: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/ug/update-activity`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getRateListByJobType: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/rate/get-ratelist-by-jobType`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },

  getAttendanceByActivity: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/ug/get-attendance-list-by-activity`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  updateAttendance: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/ug/update-attendance`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },

  // ------------------- Notification APIs--------------------
  getAllNotification: async function () {
    try {
      return axios.get(`${getServerUrl()}/notification/get-all`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  markNotificationAsRead: async function (id) {
    try {
      return axios.get(`${getServerUrl()}/notification/mark-as-read`, {
        params: { id },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  markAllNotificationsAsRead: async function () {
    try {
      return axios.get(`${getServerUrl()}/notification/mark-all-as-read`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getNotificationCount: async function () {
    try {
      return axios.get(`${getServerUrl()}/notification/get-notification-count`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getLastSyncDate: async function () {
    try {
      return axios.get(`${getServerUrl()}/sync-date`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  syncMasterData: async function () {
    try {
      return axios.get(`${getServerUrl()}/sync-data`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getAllDepartmentList: async function () {
    try {
      return axios.get(`${getServerUrl()}/user/get-all-department`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getAllGandForDropdown: async function () {
    try {
      return axios.get(`${getServerUrl()}/employee/merge-data`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getMonthlyWorkReport: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/employee/gang-monthly-earning`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  // ------------------- Shift Management APIs --------------------
  getAllShifts: async function (dataToSend) {
    try {
      return axios.get(`${getServerUrl()}/shift/get-all-shifts`, {
        params: dataToSend,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  getShiftById: async function (id) {
    try {
      return axios.get(`${getServerUrl()}/shift/get-shift-by-id`, {
        params: { id },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  addShift: async function (dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/shift/add-shift`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  updateShift: async function (id, dataToSend) {
    try {
      return axios.post(`${getServerUrl()}/shift/update-shift`, dataToSend, {
        params: { id },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
    } catch (error) {
      toast.error(error?.message);
    }
  },
  deleteShift: async function (id) {
    try {
      return axios.post(
        `${getServerUrl()}/shift/delete-shift`,
        {},
        {
          params: { id },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
    } catch (error) {
      toast.error(error?.message);
    }
  },
};
